<script>
  import MemoryListItem from "../MemoryComponents/MemoryListItem.svelte";
  import WaitlistCTA from "./WaitlistCTA.svelte";
  import {s3linkfrom} from "../AppState/EndpointsAndTransforms";
</script>

<main>
  <h2>This is Cody.</h2>
  <p>Our family's first dog.</p>
  <MemoryListItem memoryUUID='6BF1A698-56CC-40F6-8D67-0A98DC506853'/>

  <h2>Cody had a bunch of brothers and one sister, but he was the biggest and fluffiest of his litter.</h2>
  <p> We loved him immediately!</p>
  <MemoryListItem memoryUUID='A1FFD754-AD11-4E60-A06B-04BEC21F089D'/>

  <h2>Cody adjusted to life at home pretty quickly.</h2>
  <MemoryListItem memoryUUID='DFB6F6AE-6701-460A-BE64-CC19647544FC'/>

  <h2>He grew up with Rocket.</h2>
  <p> Despite the massive size difference, they both thought they were definitely brothers, and did everything together.</p>
  <MemoryListItem memoryUUID='502809B4-AF10-42FA-B6B3-9B126D3E965F'/>

  <h2>He loved the mountains and the outdoors.</h2>
  <MemoryListItem memoryUUID='5D41C3E4-2FFF-4400-988E-0C1BE327495A'/>

  <h2>He brought so much pure joy and love to our lives.</h2>
  <MemoryListItem memoryUUID='7FF20961-463C-4BC9-A618-F80218B5FA69'/>

  <h2>His auto-immune disease didn't show up at first, and even after it did, life still seemed manageable for him.</h2>
  <MemoryListItem memoryUUID='8485680A-F357-4C86-9B1F-B39779B2C8E5'/>

  <h2>He's gone now.</h2>
  <h2>He held on for a while</h2>
  <p>and was there when my baby son was born.</p>
  <MemoryListItem memoryUUID='8928D3D2-E308-4AE4-9634-BA2FFE792FEB'/>
  <p>He probably knew it was the end long before we did, but didn't show it. He was always just so thrilled to embrace every new day.</p>
  <MemoryListItem memoryUUID='975265F3-2E9D-4821-98FA-111BDD48F48C'/>

  <h2>I miss him like crazy. I still think about him all the time.</h2>
  <img src={s3linkfrom('8F13871C-2753-49B5-9A55-5BD320474E7B')} />

  <h2>I want more than just memories of him scattered throughout the past 3 years of my phone's photo albumn.</h2>
  <p>I want to tell you stories about him. Stories beyond what a basic slideshow can tell.</p>
  <MemoryListItem memoryUUID='A52037CB-B87B-470B-A6AD-AF0CBC3FF25C'/>

  <h2>I want to tell myself stories about him. To remember the best moments, the most beautiful small details. The memories I wish would outlive he and I both somehow.</h2>
  <p>To look back decades from now and remember my friend.</p>
  <img src={s3linkfrom('9D272A2C-77C9-47FA-B082-31D24AFD702A')} />

  <h2>So I built this place.</h2>
  <p>A way to keep the stories about him alive as long as I can.</p>
  <img src={s3linkfrom('7E70AF8B-4451-4A20-B4B4-354D637B1491')} />
  <p>A way to capture part of the magic we shared together, and share it with my fellow animal lovers around the world.</p>
  <p>Maybe you can relate. Maybe you'd like to share your stories too. I would be thrilled if you'd did!</p>

  <WaitlistCTA/>
</main>

<style>
  main {
    margin-top: -150px;
    max-width: 1800px;
  }

  img {
    box-shadow: 0 10px 7px -3px #272d35;
    border-radius: 8px;
    margin-left: 5px;
    margin-right: 5px;
    max-width: 400px;
    height: auto;
  }

  h2 {
    color: rgb(39,39,41);
    font-size: 2.3rem;
    margin-top: 200px;
    margin-bottom: 20px;
    margin-left: 40px;
    max-width: 58rem;
    text-align: left;
  }

  p {
    color: rgb(39,39,41);
    font-size: 24px;
    /*font-weight: 200;*/
    font-style: normal;
    max-width: 58rem;
    text-align: left;
    margin-left: 100px;
  }
</style>